import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalRoadmapPage } from 'src/app/model/page/group/iag-portal/iag-portal-roadmap-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-roadmap-page',
  templateUrl: './iag-portal-roadmap-page.component.html',
  styleUrls: ['./iag-portal-roadmap-page.component.scss']
})
export class IagPortalRoadmapPageComponent implements OnInit {
  iagPortalRoadmapPage: IagPortalRoadmapPage = {} as IagPortalRoadmapPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-roadmap') {
        this.iagPortalRoadmapPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalRoadmapPage.sections = [];
    this.iagPortalRoadmapPage.iagPortalRoadmapSection = [];

    const query = { 'fields.title': 'IAG Booking Portals Roadmap' };
    this.contentfulService.getPageContentResponse(query).then((iagPortalRoadmapPageEntries) => {
      this.mapBanner(iagPortalRoadmapPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalRoadmapPage.banner);
      this.mapPageInfo(iagPortalRoadmapPageEntries.items);
      this.mapSections(iagPortalRoadmapPageEntries.includes.Entry);
    });
  }

  private mapBanner(iagPortalRoadmapPageEntries: Entry<any>[]) {
    iagPortalRoadmapPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];

    this.iagPortalRoadmapPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalRoadmapPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalRoadmapPage.banner.url = entry.fields?.url;
      this.iagPortalRoadmapPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalRoadmapPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalRoadmapPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalRoadmapPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(iagPortalRoadmapPageEntries: Entry<any>[]) {
    iagPortalRoadmapPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToLeftRightSection(entry);
      });
    this.iagPortalRoadmapPage.iagPortalRoadmapSection.sort((a, b) => a.order - b.order);
  }

  private mapEntryToLeftRightSection(entry: Entry<any>) {
    this.iagPortalRoadmapPage.iagPortalRoadmapSection.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body']  as string,
      group: entry.fields['group']  as string,
      order: entry.fields['order'] as number,
      position: entry.fields['position'] as string,
      category: entry.fields['category'] as string,
      heading: entry.fields['heading']  as string,
      subBody: entry.fields['subBody'] as string,
      sectionClass: entry.fields['sectionClass'] as string
    });
  }
}
